import React from 'react';
import AppDropdown from './AppDropdown';
import { INDIAN_STATES } from '../data/indiaStates';

const STATE_OPTIONS = INDIAN_STATES.map((s) => ({ value: s, label: s }));

/**
 * Searchable Indian state selector.
 * Renders only the dropdown control — wrap it with your own label/field markup.
 * `onChange` receives the selected state name (string).
 */
const StateSelect = ({
  value,
  onChange,
  placeholder = 'Select State',
  menuWidth = 240,
  menuClassName = 'crm-dropdown-window',
  disabled = false,
}) => (
  <AppDropdown
    value={value || ''}
    options={STATE_OPTIONS}
    onChange={onChange}
    placeholder={placeholder}
    disabled={disabled}
    searchable
    minSearchChars={1}
    searchPlaceholder="Type to search state..."
    menuWidth={menuWidth}
    menuClassName={menuClassName}
  />
);

export default StateSelect;
